module.exports = __webpack_public_path__ + "media/images/top/keisan_dojo_index_show-min-9b54f64832790e05f5ec2d42ec18afc7.png";